import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PaginatedResponse } from '../../models/paginated-response';

@Injectable({
  providedIn: 'root'
})
export class MobileUserService {
  private readonly apiUrl = `${environment.apiGatewayBaseUrl}/MobileUsers`;
  private readonly authApiUrl = `${environment.apiGatewayBaseUrl}/api/UserAuth`;

  constructor(private http: HttpClient) { }

  getAllMobileUsers(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`);
  }

  getAllMobileUsersPaginated(
    pageNumber?: number,
    pageSize?: number,
    filterCompanyId?: number | string | null,
    filterUserType?: string | null,
    filterStartDate?: string | null,
    filterEndDate?: string | null
  ): Observable<PaginatedResponse<any>> {
    let params = new HttpParams();

    if (pageNumber !== undefined && pageNumber !== null) {
      params = params.set('pageNumber', pageNumber.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (filterCompanyId !== undefined && filterCompanyId !== null) {
      params = params.set('companyId', filterCompanyId.toString());
    }
    if (filterUserType) {
      params = params.set('userType', filterUserType);
    }
    if (filterStartDate) {
      params = params.set('startDate', filterStartDate);
    }
    if (filterEndDate) {
      params = params.set('endDate', filterEndDate);
    }

    return this.http.get<PaginatedResponse<any>>(
      `${this.apiUrl}/paginated`,
      { params }
    );
  }

  searchMobileUsers(
    pageNumber: number,
    pageSize: number,
    filterType: string,
    filterValue: string
  ): Observable<PaginatedResponse<any>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
      .set('filterType', filterType)
      .set('filterValue', filterValue);

    return this.http.get<PaginatedResponse<any>>(
      `${this.apiUrl}/search`,
      { params }
    );
  }

  updateMobileUser(id: number, updatedAdmin: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, updatedAdmin);
  }

  toggleMobileUserStatus(cid: number, performedBy: number, blockReason?: string): Observable<any> {
    return this.http.post<any>(`${this.authApiUrl}/ToggleMobileUserStatus`, { cid, performedBy, blockReason: blockReason ?? null });
  }

}
